export type CreateResourceRequest = BaseIndentAPIRequest & {
  spaceName: string
  resource: Resource
}

export type UpdateResourceRequest = BaseIndentAPIRequest & {
  spaceName: string
  resourceName: string
  resource: Resource
}

export type BulkUpdateResourcesRequest = BaseIndentAPIRequest & {
  spaceName: string
  resources: Resource[]
  opts?: { fields: [] }
}

export type PullUpdateResourcesRequest = BaseIndentAPIRequest & {
  spaceName: string
  kinds: string[]
  flags?: PullUpdateResourcesFlags
}

export type PullUpdateResourcesFlags = Record<string, string>

export type DeleteResourceRequest = BaseIndentAPIRequest & {
  spaceName: string
  resourceName: string
}

export type BulkDeleteResourcesRequest = BaseIndentAPIRequest & {
  spaceName: string
  resourceNames: string[]
}

export type GetResourceRequest = BaseIndentAPIRequest & {
  spaceName: string
  resourceName: string
}

export type ListResourcesRequest = BaseIndentAPIRequest & {
  spaceName: string
  labelSelector?: string
  latest?: boolean
  view?: string
  pageSize?: number
  pageToken?: string
}

export type ListResourcesResponse = {
  nextPageToken: string
  resources: Resource[]
}